/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { DialogDefaultV2, InputV2 } from '../../../components/v2';

const ValidarDialog = ({ open, onClose, onConfirm }) => {
  const [protocoloAnac, setProtocoloAnac] = useState('');

  useEffect(() => {
    if (open) setProtocoloAnac('');
  }, [open]);

  const handleConfirm = () => {
    onConfirm(protocoloAnac || null);
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Validar Pedido de Voo"
      confirmMessage="Validar"
      cancelMessage="Cancelar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Informe o Protocolo ANAC para validar o pedido. O campo é opcional — você pode validar sem informar o protocolo agora.
      </Typography>
      <InputV2
        label="Protocolo ANAC"
        value={protocoloAnac}
        onChange={(e) => setProtocoloAnac(e.target.value)}
      />
    </DialogDefaultV2>
  );
};

ValidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ValidarDialog;
